import { Group, Burger, Button, ActionIcon, useMantineColorScheme, Image } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

interface HeaderProps {
  mobileOpened: boolean;
  onToggle: () => void;
}

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Our Story', href: '/our-story' },
  { label: 'Solutions', href: '/solutions' },
  { label: 'In Action', href: '/in-action' },
  { label: 'Join Us', href: '/join-us' },
  { label: 'Contact', href: '/contact' },
];

export default function Header({ mobileOpened, onToggle }: HeaderProps) {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isDark = colorScheme === 'dark';

  // Close mobile nav on route change
  useEffect(() => {
    // MobileNav handles its own close
  }, [location.pathname]);

  return (
    <Group h="100%" px="md" justify="space-between" style={{ maxWidth: 1280, margin: '0 auto', width: '100%' }}>
      {/* Logo */}
      <Group>
        <Burger opened={mobileOpened} onClick={onToggle} hiddenFrom="md" size="sm" />
        <Image
          src="/logo.png"
          alt="CamGlass"
          h={40}
          w="auto"
          fallbackSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjQwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxNjAiIGhlaWdodD0iNDAiIGZpbGw9IiMxQTFCMUUiLz48dGV4dCB4PSI4MCIgeT0iMjgiIGZvbnQtZmFtaWx5PSJPdXRmaXQiIGZvbnQtd2VpZ2h0PSI3MDAiIGZvbnQtc2l6ZT0iMjAiIGZpbGw9IiMwMGFhY2IiIHRleHQtYW5jaG9yPSJtaWRkbGUiPkNhbUdsYXNzPC90ZXh0Pjwvc3ZnPg=="
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
      </Group>

      {/* Desktop Nav */}
      <Group gap="sm" visibleFrom="md">
        {navLinks.map((link) => {
          const isActive = location.pathname === link.href ||
            (link.href !== '/' && location.pathname.startsWith(link.href));
          return (
            <Button
              key={link.href}
              variant={isActive ? 'light' : 'subtle'}
              color={isActive ? 'gold' : 'gray'}
              size="sm"
              onClick={() => navigate(link.href)}
              styles={{
                root: {
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#ffbe00' : undefined,
                  '&:hover': { color: '#ffbe00' },
                },
              }}
            >
              {link.label}
            </Button>
          );
        })}
      </Group>

      {/* Right side */}
      <Group gap="xs">
        <ActionIcon
          variant="subtle"
          color="gray"
          onClick={() => toggleColorScheme()}
          size="lg"
          aria-label="Toggle color scheme"
        >
          {isDark ? <IconSun size={18} /> : <IconMoon size={18} />}
        </ActionIcon>
        <Button
          color="gold"
          size="sm"
          radius="md"
          visibleFrom="sm"
          onClick={() => navigate('/request-quote')}
        >
          Request Quote
        </Button>
      </Group>
    </Group>
  );
}
